import React, { useEffect, useRef } from 'react';

interface LogoImageProps {
    imageUrl: string;
    containerSize?: number;
}

const LogoImage: React.FunctionComponent<LogoImageProps> = ({imageUrl, containerSize = 280}) => {
    const imageRef = useRef<HTMLImageElement>(null);

    useEffect(() => {
        const image = imageRef.current;
        if (!image) return;

        const handleImageLoad = () => {
            const width = image.naturalWidth;
            const height = image.naturalHeight;

            const aspectRatio = width / height;

            let newWidth: number;
            let newHeight: number;

            if (aspectRatio >= 1) {
                newWidth = containerSize;
                newHeight = newWidth / aspectRatio;
            } else {
                newHeight = containerSize;
                newWidth = newHeight * aspectRatio;
            }

            image.style.width = `${newWidth}px`;
            image.style.height = `${newHeight}px`;
        };

        image.addEventListener('load', handleImageLoad);
        image.src = imageUrl;

        return () => {
            image.removeEventListener('load', handleImageLoad);
        };
    }, [imageUrl, containerSize]);

    return (
        <img
            ref={imageRef}
            src={imageUrl}
            alt="Logo"
            style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'cover',
            }}
        />
    );
};

export default LogoImage;
